import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon } from 'lucide-react';
const testimonials = [{
  initials: 'M.R.',
  quote: <>
        I've been grilling for{' '}
        <span className="text-[#E69D4F] font-semibold" data-id="element-122">15 years</span> and
        thought I knew what I was doing. The{' '}
        <span className="text-[#E69D4F] font-semibold" data-id="element-123">Heat-Flow method</span>{' '}
        completely changed my game. My last brisket got{' '}
        <span className="text-[#E69D4F] font-semibold" data-id="element-124">actual applause</span>.
      </>,
  name: 'Mike R.',
  location: 'Austin, TX',
  color: 'bg-[#E69D4F]'
}, {
  initials: 'S.T.',
  quote: <>
        Followed the system on my{' '}
        <span className="text-[#E69D4F] font-semibold" data-id="element-125">basic Weber kettle</span>
        . My wife said it was the{' '}
        <span className="text-[#E69D4F] font-semibold" data-id="element-126">
          best meal I've ever made
        </span>
        . The science behind it just{' '}
        <span className="text-[#E69D4F] font-semibold" data-id="element-127">clicks</span>.
      </>,
  name: 'Sarah T.',
  location: 'Charlotte, NC',
  color: 'bg-[#C45F2A]'
}];
export function SocialProof() {
  return <section className="py-16 md:py-20 px-4 bg-dark-contrast" data-id="element-128">
      <div className="max-w-5xl mx-auto" data-id="element-129">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-10" data-id="element-130">
          <h2 className="font-heading text-4xl md:text-5xl font-black text-ivory uppercase tracking-tight" data-id="element-131">
            What <span className="text-[#E69D4F]" data-id="element-132">Pitmasters</span> Are Saying
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-133">
          {testimonials.map((testimonial, index) => <motion.div key={index} initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.2
        }} className="bg-dark-elevated rounded-2xl p-6 md:p-10 border border-[#333] shadow-xl" data-id="element-134">
              <div className="flex items-center gap-4 md:gap-6 mb-4" data-id="element-135">
                <div className={`w-14 h-14 md:w-16 md:h-16 rounded-full flex items-center justify-center text-dark font-black text-xl md:text-2xl shrink-0 ${testimonial.color}`} data-id="element-136">
                  {testimonial.initials}
                </div>
                <div data-id="element-137">
                  <p className="text-ivory font-bold text-base md:text-lg" data-id="element-138">
                    {testimonial.name}
                  </p>
                  <p className="text-smoke text-xs md:text-sm" data-id="element-139">
                    {testimonial.location}
                  </p>
                </div>
              </div>

              <div className="flex gap-1 mb-4 md:mb-6" data-id="element-140">
                {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-4 h-4 md:w-5 md:h-5 fill-[#FFC107] text-[#FFC107]" data-id="element-141" />)}
              </div>

              <p className="text-ivory text-base md:text-xl italic leading-relaxed" data-id="element-142">
                "{testimonial.quote}"
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}